import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import CustomInput from '../CustomInput/CustomInput';
import CustomBtn from '../CustomBtn/CustomBtn';
import { toast } from "react-toastify";
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import imgsm from '../../assets/logoSm.png'
import  './CodeForm.css'
function CodeForm() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [modalShow, setModalShow] = useState(false);
  const [status, setStatus] = useState(null);
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className='border-0 pb-1 pt-3'></Modal.Header>
        <Modal.Body>
          {status === 1 ? (
            <>
              <div className='d-flex justify-content-center mb-4'>
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="green" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
              </div>
              <p className='text-center fw-bold'>{msg}</p>
            </>
          ) : (
            <>
              <div className='d-flex justify-content-center mb-4'>
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="red" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                </svg>
              </div>
              <p className='text-center fw-bold'>{msg}</p>
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }

const convertArabicToEnglishNumbers = (str) => {
  return str.replace(/[\u0660-\u0669]/g, (c) => c.charCodeAt(0) - 0x0660)
            .replace(/[\u06F0-\u06F9]/g, (c) => c.charCodeAt(0) - 0x06F0);
};

  return (
    <div className='py-5 code_result_container'>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <h4 className='text-center'>{currentLocal?.home?.ProductAuthenticityCheck}</h4>
      <div className='d-flex flex-direction-column justify-content-center align-items-center mt-5'>
        <form className=' submit_code_form' style={{width: "50%",}}onSubmit={(e) => {
e.preventDefault(); 
          if (!code) {
            toast.error(currentLocal.home.fillFieldCode, { position: "bottom-right", autoClose: 3000 });
          } else {
            
              navigate(`/Product/Verify/result/${code}`)

          }

        }}>
          <div className='text-center'>

            <img src={imgsm}alt=''className='w-75 mb-3'/>
          </div>
          <CustomInput
            placeholder={currentLocal.home.enterCode}
            value={code}
  onChange={(e) => {
    const englishCode = convertArabicToEnglishNumbers(e.target.value);
    setCode(englishCode);
  }}
          />
          <div className='d-flex justify-content-center'>
            <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.Verify} disabled={loading}  />
          </div>
        </form>
      </div>
    </div>
  );
}

export default CodeForm;
